import { Injectable } from '@angular/core';
import { ListPageState } from './shared-service.types';

/**
 * Preserves list view page state (pagination, filters, etc)
 * State is keyed by a string constant defined for each list component (eg METADATA_SEARCH_STATE_KEY)
 * State is kept for the lifetime of the session and is cleared when the user navigates to a different root route
 */
@Injectable({ providedIn: 'root' })
export class PageStateService {
  private states = new Map<string, ListPageState>();

  // Saves the current page state for the given key, replacing any previously saved state
  save(key: string, state: ListPageState): void {
    this.states.set(key, state);
  }

 // Returns the saved state for the given key, cast to the expected type T
  get<T extends ListPageState>(key: string): T {
    return (this.states.get(key) as T);
  }

 // Removes the saved state for a single key
  clear(key: string): void {
    this.states.delete(key);
  }

  // Removes all saved state. Called on root route change to prevent stale state persisting across sections
  clearAll(): void {
    this.states.clear();
  }
}
